import React from 'react';
import _ from 'lodash';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

class RightArea extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { fetchEmergencyDetails, assignedOfficeId, emergencyBuildingId } = this.props;
    fetchEmergencyDetails(emergencyBuildingId || assignedOfficeId);
  }

  render() {
    const { emergencyDetails } = this.props;
    const firstText = _.get(emergencyDetails, 'first', '');
    const secondText = _.get(emergencyDetails, 'second', '');

    return (
      <div className="right-container">
        {_.isString(firstText) && !_.isEmpty(firstText) ? parse(firstText) : null}
        {_.isString(secondText) && !_.isEmpty(secondText) ? parse(secondText) : null}
      </div>
    );
  }
}

RightArea.propTypes = {
  emergencyDetails: PropTypes.shape().isRequired,
  fetchEmergencyDetails: PropTypes.func.isRequired,
  assignedOfficeId: PropTypes.number,
  emergencyBuildingId: PropTypes.number,
};

RightArea.defaultProps = {
  assignedOfficeId: null,
  emergencyBuildingId: null,
};

export default RightArea;
